module.exports = __webpack_public_path__ + "media/components/assets/icons/aside_arrow_r_bold-9c3e8dc97332a797604bd10907b93580.svg";